<template>
  <v-container id="invoice-items">
    <v-data-table
        :headers="formattedHeaders"
        :items="visibleInvoiceItems"
        :hide-default-footer="true"
        :disable-sort="true"
        :hide-default-header="true"
      >
      <template v-slot:header="{ props }">
        <thead>
          <tr>
            <th
              v-for="header in props.headers"
              :key="header.text"
              class="custom-header"
              style=" border-bottom: thin solid rgb(0 0 0 / 0%);"
            >
              <p>{{ header.text }}</p>
            </th>
          </tr>
        </thead>
      </template>
        <template v-slot:item="{ item, index }">
          <tr>
            <td class="wider-description">
              <v-text-field
                v-model="item.description"
                placeholder="Description"
                outlined 
                dense
                clearable
              ></v-text-field>
            </td>
            <td >
              <v-text-field
                v-model="item.quantity"
                type="number"
                dense
                oninput="validity.valid||(value='');"
                min="0"
                outlined 
                clearable
                @input="updateTotal(item)"
              ></v-text-field>
            </td>
            <td>
              <v-text-field
                v-model="item.unit_price"
                type="number"
                dense
                min="0" 
                onkeyup="if(this.value<0){this.value= this.value * -1}"
                outlined 
                clearable
                @input="updateTotal(item)"
              ></v-text-field>
            </td>
            <td>
              <v-text-field
                v-model="item.gst"
                type="number"
                dense
                outlined 
                clearable
                @input="updateTotal(item)"
                disabled
              ></v-text-field>
            </td>
            <td><v-text-field
                v-model="item.amount"
                dense
                outlined 
                disabled
              ></v-text-field></td>
            <td class="pb-5">
              <v-icon
                size="30"
                @click="deleteItem(index)"
                color="red"
              >
                mdi-delete
              </v-icon>
            </td>
          </tr>
        </template>
      </v-data-table>
      <v-row class="mt-0">
        <v-col v-if="!addingNewRow" class="text-left">
          <v-icon  size="40" color="blue" @click="addNewRow">mdi-plus</v-icon>
        </v-col>
      </v-row>
  </v-container>
</template>

<style scoped>
  .v-text-field--outlined >>> fieldset {
      border-color: rgba(192, 0, 250, 0.215);
      border-radius: 10px;
  }
</style>

<script>

import { createNamespacedHelpers } from "vuex";
const { mapGetters: mapSettingsGetters } = createNamespacedHelpers('settings');

export default {
  props:{
    initialItems: Array
  },
  data() {
    return {
      headers: [
        { text: 'Description', value: 'description' },
        { text: 'Quantity', value: 'quantity' },
        { text: 'Unit Price', value: 'unit_price' },
        { text: 'GST (%)', value: 'gst' },
        { text: 'Amount (AUD)', value: 'amount' },
        { text: '', value: 'actions', sortable: false }
      ],
      invoiceItems: [],
      addingNewRow: false,
    };
  },
  computed: {
  ...mapSettingsGetters({
    currencyCode: 'currencyCode',
    taxType: 'taxType',
  }),
  formattedHeaders() {
    return this.headers.map(header => {
      if (header.text.includes('Amount')) {
        return { ...header, text: header.text.replace('(AUD)', `(${this.currencyCode})`) };
      }
      if (header.text.includes('GST')) {
        return { ...header, text: header.text.replace('GST', `${this.taxType}`) };
      }
      return header;
    });
  },

  visibleInvoiceItems() {
    return this.invoiceItems.filter(item => !item.deleted);
  },
},
  created() {
    if (this.initialItems && this.initialItems.length > 0) {
      this.invoiceItems = [...this.initialItems];
    } else {
      this.invoiceItems.push({ description: '', quantity: 0, unit_price: 0, gst: 10, amount: 0 });
    }
  },
  watch: {
    initialItems: {
      immediate: true, 
      handler(newVal) {
        if (newVal && newVal.length > 0) {
          this.invoiceItems = [...newVal];
        } else {
          this.invoiceItems.push({ description: '', quantity: 0, unit_price: 0, gst: 10, amount: 0 });
        }
      },
    },
    invoiceItems: {
      deep: true,
      handler(newValue) {
        this.calculateTotalGST();
        const data = newValue.filter(item => item.description !== '');
        this.$emit('invoice-items', data);
      },
    },
  },
  methods: {
    updateTotal(item) {
      item.amount = (item.quantity || 0) * (item.unit_price || 0);
    },
    deleteItem(index) {
      this.invoiceItems.splice(index, 1);
    },
    addNewRow() {
      this.addingNewRow = true;
      this.$nextTick(() => {
        this.invoiceItems.push({ description: '', quantity: 0, unit_price: 0, gst: 10, amount: 0 });
        this.addingNewRow = false;
      });
    },
    calculateTotalGST() {
      this.invoiceItems.forEach(item => {
        item.totalGST = (item.amount || 0) * (item.gst || 0) / 100;
      });
    }
  },
};
</script>